import { useState } from 'react'
import clsx from 'clsx'

import { Container } from './Container'
import { Expandable } from './Expandable'


const testimonials = [
  [
    {
      content:
        'PortalJS Cloud enabled us to set up and publish an open data portal in record time. We were able to upload datasets and organize over 100 data sources into a platform that is both visually appealing and easy to use. We also greatly appreciated the excellent support provided throughout the project.',
      author: {
        name: 'Pere Rovira',
        role: 'Founder and Chief Strategy Officer at <a href="https://onetandem.com/" target="_blank"><span>OneTandem</span></a>',
        image: 'assets/images/pages/showcase/Pere-Rovira.jpg',
      },
    },
    {
      content: [
        'Datopian’s work has had a significant impact on our organisation by providing SSEN Distribution with a modern Open Data Portal that is user-friendly, scalable and capable of evolving alongside our future data-sharing ambitions. The platform gives our customers and stakeholders a clear, accessible route to discover, understand and use our data, while also providing a strong foundation for further automation, integration and enhanced visualisation.',
        'Their team has been consistently supportive and collaborative, responding quickly and professionally to issues, feedback and emerging requirements. This has enabled us to make improvements at pace and maintain momentum across a complex programme of work.',
        'Organisationally, the portal has strengthened our ability to share data openly and transparently and has helped differentiate SSEN Distribution from many other Distribution Network Operators. It positions us well to respond to evolving user needs, regulatory expectations and wider industry developments, while supporting our longer-term ambition to provide seamless access to high-quality data and actionable insight.',
      ],
      author: {
        name: 'Richard Baker',
        role: 'Business Analyst at <a href="https://www.ssen.co.uk/" target="_blank"><span>Scottish and Southern Electricity Networks</span></a>',
        image: 'assets/images/pages/showcase/ssen-logo.png',
      },
    },
    {
      content:
        'Datopian demonstrated clear communication and a strong understanding of our requirements throughout the project. Their structured, collaborative approach to development made the process smooth and transparent, and their team was consistently easy to reach, supportive, and a pleasure to work with.',
      author: {
        name: 'Maria Thernström',
        role: 'Service Owner for Open Data at <a href="https://opendata.malmo.se/en" target="_blank"><span>The City of Malmö</span></a>',
        image: 'assets/images/pages/showcase/citymalmo.png',
      },
    },
    {
      content:
        'The ability of CKAN to grow with us as we mature is critical and one of the main reasons we chose it.',
      author: {
        name: 'Marty Hall',
        role: 'Senior Information Technology Manager at <a href="https://www.gatesfoundation.org/" target="_blank"><span>Bill & Melinda Gates Foundation</span></a>',
        image: 'assets/images/pages/showcase/marty-hall.jpg',
      },
    },
    {
      content:
        'Simplicity is key. I’ve worked with other systems [than CKAN] to publish data that were very onerous to use and very off-putting from that perspective.',
      author: {
        name: 'Cormac McConaghy',
        role: 'CT Lead at <a href="https://www.opendatani.gov.uk/" target="_blank"><span>Open Data Northern Ireland </span></a>',
        image: 'assets/images/pages/showcase/Cormac-McConaghy.png',
      },
    },

  ],
  [
    {
      content:
        'Datopian made it possible to have a new City of Malmö Open Data portal up and running as of January 1st, 2026. We are very pleased with the Datopian team and have made great progress in establishing and enhancing the portal to comply with the City of Malmö\'s requirements. We now have a user-friendly and inviting open data portal with the City of Malmö\'s look and feel. Datopian ensured that the City of Malmö could switch over to the new open data portal without interruption.',
      author: {
        name: 'Maria Thernström',
        role: 'Service Owner for Open Data at <a href="https://opendata.malmo.se/en" target="_blank"><span>The City of Malmö</span></a>',
        image: 'assets/images/pages/showcase/citymalmo.png',
      },
    },
    {
      content:
        'Things like DCAT metadata standards, and making it as simple as possible for an organisation to take a dataset and put it on the portal, was very much the original idea around using CKAN.',
      author: {
        name: 'Cormac McConaghy',
        role: 'CT Lead at <a href="https://www.opendatani.gov.uk/" target="_blank"><span>Open Data Northern Ireland </span></a>',
        image: 'assets/images/pages/showcase/Cormac-McConaghy.png',
      },
    },
    {
      content:
        'CKAN has been a great success for National Grid, it has delivered a lot.',
      author: {
        name: 'Nikhil Madani',
        role: 'Data Platforms Product Manager at <a href="https://www.nationalgrideso.com/" target="_blank"><span>National Grid ESO</span></a>',
        image: 'assets/images/pages/showcase/Nikhil-Madani.jpg',
      },
    },

    {
      content:
        "CKAN is quite flexible, It integrates with new technologies fast, and we've been able to show that to stakeholders, both internally and externally.",
      author: {
        name: 'Nikhil Madani',
        role: 'Data Platforms Product Manager at <a href="https://www.nationalgrideso.com/" target="_blank"><span>National Grid ESO</span></a>',
        image: 'assets/images/pages/showcase/Nikhil-Madani.jpg',
      },
    },
    {
      content:
        "I would like to take this opportunity to extend my heartfelt gratitude for the outstanding support and collaboration your team has offered over the past year. The agility, technical prowess, and steadfast dedication you have demonstrated are truly commendable. Your efforts have been integral to our successes, and I am deeply appreciative. I am hopeful that there will be opportunities for me to engage with future projects and contribute. Thank you once again for your exemplary contribution and for the positive spirit you bring to our work.",
      author: {
        name: 'Shailesh Kumar',
        role: 'Analytics and Data Architect at <a href="https://www.ssen.co.uk/" target="_blank"><span>SSEN</span></a>',
        image: 'assets/images/pages/showcase/ssen-logo.png',
      },
    },
  ],
  [
    {
      content:
        'I had the privilege of working with Datopian for a period of about 2 years. I joined the project later on, during Phase 2 of the project, so Datopian\'s knowledge and patience to help me in that transition was essential and greatly appreciated. Whenever we had questions or needed clarification on complex topics, the team was always committed to help, whether in a dedicated session or by taking time to write up documentation. We chose Datopian for their experience with CKAN and it\'s clear they are very knowledgeable and care about the work they do. Above all, I enjoyed working with Osahon, Maira, and team for their friendly demeanors and reliable communication.',
      author: {
        name: 'Kim Thornton',
        role: 'Product Manager at <a href="https://www.wri.org/" target="_blank"><span>World Resources Institute</span></a>',
        image: 'assets/images/pages/showcase/wri_logo.png',
      },
    },
    {
      content:
        "We worked with Datopian since 2017 as providers of Perth & Kinross Council's first Open Data Portal. The portal met all our requirements, was reliable, and performed well. We had a good working relationship with Datopian throughout and found their service to be responsive, effective, and delivered professionally.",
      author: {
        name: 'Ewan Walker',
        role: 'Data Services Team Leader at <a href="https://www.pkc.gov.uk" target="_blank"><span>Perth & Kinross Council</span></a>',
        image: 'assets/images/pages/showcase/Ewan-Walker.jpg',
      },
    },
    {
      content:
        "We're working on a CKAN platform for all our datasets - and it has been a strategic choice to use CKAN.",
      author: {
        name: 'Heidi Bøjlesen',
        role: ' IT Project Manager at <a href="https://energinet.dk/" target="_blank"><span>Energinet</span></a>',
        image: 'assets/images/pages/showcase/Heidi-Bøjlesen.jpg',
      },
    },
    {
      content:
        'We looked at CKAN as a good benchmark to work towards.',
      author: {
        name: 'Jonathan Challener',
        role: 'Partnerships and Community Manager at <a href="https://www.oecd.org/ "target="_blank"><span>OECD</span></a>',
        image: 'assets/images/pages/showcase/Jonathan-Challener.jpg',
      },
    },
    {
      content:
        'It truly is that simple - we don’t want it to be another level of complexity to what they [our civil servants] do, we don’t want it to take 10 minutes to publish.',
      author: {
        name: 'Cormac McConaghy',
        role: 'CT Lead at <a href="https://www.opendatani.gov.uk/" target="_blank"><span>Open Data Northern Ireland </span></a>',
        image: 'assets/images/pages/showcase/Cormac-McConaghy.png',
      },
    },
    {
      content:
        'The sheer flexibility and the open-source nature of CKAN was appealing.',
      author: {
        name: 'Doug Young',
        role: ' Development Officer at <a href="https://scottishcities.org.uk/" target="_blank"><span>Scottish Cities Alliance</span></a>',
        image: 'assets/images/pages/showcase/Doug-Young.jpg',
      },
    },
  ],
]

function Testimonial({ author, content }) {
  let [isExpanded, setIsExpanded] = useState(false)
  let paragraphs = Array.isArray(content) ? content : [content]
  let isLong = paragraphs.length > 1 || paragraphs[0].length > 320

  return (
    <figure className="rounded-4xl p-8 shadow-md ring-1 ring-slate-900/5" tabIndex={0}>
      <blockquote>
        {isLong && !isExpanded ? (
          <p className="text-lg tracking-tight text-slate-900 body-text line-clamp-4">
            {paragraphs[0]}
          </p>
        ) : (
          paragraphs.map((paragraph, index) => (
            <p
              key={index}
              className={clsx(
                'text-lg tracking-tight text-slate-900 body-text',
                index > 0 && 'mt-4',
              )}
            >
              {paragraph}
            </p>
          ))
        )}
        {isLong && (
          <button
            type="button"
            className="mt-3 font-['Inter'] text-sm font-medium text-slate-500 hover:text-slate-700"
            onClick={() => setIsExpanded((expanded) => !expanded)}
          >
            {isExpanded ? 'Show less' : 'Read more'}
          </button>
        )}
      </blockquote>
      <figcaption className="mt-6 flex items-center">
        <div className="md:w-fit xl:w-[20%] w-[20%] ">
          <div className='overflow-hidden rounded-full w-fit  bg-slate-50'>
            <img
              className="w-8 h-8 md:h-12 md:w-12 object-cover"
              src={author.image}
              alt={author.name}
              width={48}
              height={48}
            />
          </div>

        </div>
        <div className="ml-4 md:w-fit xl:w-[80%] w-[80%]">
          <div className="text-base font-['Inter'] font-medium leading-6 tracking-tight text-slate-900">
            {author.name}
          </div>
          <div className="descp mt-1 text-sm text-slate-600  font-['Inter'] " dangerouslySetInnerHTML={{ __html: author.role }}></div>
        </div>
      </figcaption>
    </figure>
  )
}

export function Testimonials() {
  return (
    <section className="py-8 sm:py-10 lg:py-16 px-8 sm:px-0 mx-auto xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-full rounded-md" aria-label='Testimonial Section' tabIndex={0}>
      <Expandable>
        {({ isExpanded }) => (
          <>
            <ul
              role="list"
              className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 px-4 lg:max-w-7xl lg:grid-cols-3 lg:px-8 "
              aria-roledescription='testimonial'
            >
              {testimonials
                .map((column) => column[0])
                .map((testimonial, testimonialIndex) => (
                  <li key={testimonialIndex} className="lg:hidden">
                    <Testimonial
                      author={testimonial.author}
                      content={testimonial.content}
                    />
                  </li>
                ))}
              {testimonials.map((column, columnIndex) => (
                <li
                  key={columnIndex}
                  className={isExpanded ? undefined : 'hidden lg:list-item'}
                >
                  <ul role="list">
                    {column
                      .slice(0, isExpanded ? undefined : 3)
                      .map((testimonial, testimonialIndex) => (
                        <li
                          key={testimonialIndex}
                          className={clsx(
                            testimonialIndex === 0 && 'hidden lg:list-item',
                            testimonialIndex === 1 && 'lg:mt-8 ',
                            testimonialIndex > 1 && 'mt-8',
                          )}
                        >
                          <Testimonial
                            author={testimonial.author}
                            content={testimonial.content}
                          />
                        </li>
                      ))}
                  </ul>
                </li>
              ))}
            </ul>
            <Expandable.Button>Read more testimonials</Expandable.Button>
          </>
        )}
      </Expandable>
    </section>
  )
}
